export default __webpack_public_path__ + "static/media/regulatory--use-crosswalk--g1.4941d3c3.png";